import React, { Component } from 'react';
import { Button, Spinner } from 'reactstrap';
// DropzoneButton (not DropzonePlusButton — the latter drops the `multiple`/`inputProps`
// props, so it can't be constrained to single-file). DropzoneButton forwards both.
import { DropzoneButton } from '../../components/Form/DropzoneFile';
import { cssUrl } from './registry';
import { createUploadFileForm, SLIDER_IMAGE_ACCEPT } from '../../utils/imageHelper/imageHelper';
import { uploadImageNoRedux } from '../../actions/imageUploadAction';

// Reuses the CMS Dropzone + asset-upload endpoint so editors actually upload/change images.
// Props: label, url, onChange(url), hint
export default class ImageUpload extends Component {
  constructor(props) {
    super(props);
    this.state = { uploading: false, error: null };
    this._mounted = false;
  }

  componentDidMount() { this._mounted = true; }

  componentWillUnmount() { this._mounted = false; }

  onDrop = async (files) => {
    const file = files && files[0];
    if (!file) return;
    this.setState({ uploading: true, error: null });
    try {
      const fd = createUploadFileForm(file, false, { name: 'homepage-images', bucket_type: 'assets' });
      const res = await uploadImageNoRedux(fd);
      const data = res && res.data && res.data.data;
      const url = (data && (data.url || (data.data && data.data[0] && data.data[0].url))) || null;
      if (!this._mounted) return;
      if (url) { this.setState({ uploading: false }); this.props.onChange(url); }
      else this.setState({ uploading: false, error: 'Upload returned no URL.' });
    } catch (e) {
      if (this._mounted) this.setState({ uploading: false, error: (e && e.message) || 'Upload failed.' });
    }
  };

  render() {
    const { label, url, onChange, hint } = this.props;
    const { uploading, error } = this.state;
    return (
      <div className="form-group">
        <label className="font-weight-bold" style={{ fontSize: '.78rem' }}>{label}</label>
        <div className="d-flex align-items-center" style={{ gap: 8 }}>
          <div style={{ width: 60, height: 44, borderRadius: 4, background: url ? `#fff url('${cssUrl(url)}') center/cover no-repeat` : '#eef1f3', border: '1px solid #c8ced3', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#b5bcc3' }}>
            {url ? null : <i className="fa fa-image" />}
          </div>
          <div className="flex-fill">
            {uploading ? (
              <span className="text-muted" style={{ fontSize: '.78rem' }}><Spinner size="sm" /> Uploading…</span>
            ) : (
              <div className="d-flex align-items-center" style={{ gap: 6 }}>
                <DropzoneButton accept={SLIDER_IMAGE_ACCEPT} multiple={false} inputProps={{ multiple: false }} onDrop={this.onDrop}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '5px 10px', fontSize: '.78rem', color: '#5c6873', cursor: 'pointer' }}>
                    <i className="fa fa-upload" /> {url ? 'Replace image' : 'Drag or browse to upload'}
                  </span>
                </DropzoneButton>
                {url ? <Button size="sm" color="link" className="text-danger p-0" onClick={() => onChange('')}>Remove</Button> : null}
              </div>
            )}
          </div>
        </div>
        {error ? <small className="text-danger d-block">{error}</small> : null}
        {hint ? <small className="text-muted d-block">{hint}</small> : null}
      </div>
    );
  }
}
